module.exports = __webpack_public_path__ + "img/MagnifyingGlassMobile.5d70b6ad.svg";